/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function () {
  'use strict';

  var activeTrigger = null;
  var modal = null;
  var modalTitle = null;
  var modalLabel = null;
  var modalSelect = null;
  var modalAdd = null;
  var modalClose = null;
  var modalStatus = null;

  function localeCartUrl(path) {
    var root = window.theme && window.theme.localeRootUrl ? window.theme.localeRootUrl : '';
    return root + path;
  }

  function createModal(trigger) {
    if (modal) {
      return;
    }

    modal = document.createElement('div');
    modal.className = 'AaganQuickBuyModal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="AaganQuickBuyModal__Backdrop" data-aagan-quick-buy-close></div>' +
      '<div class="AaganQuickBuyModal__Dialog" role="dialog" aria-modal="true" aria-labelledby="AaganQuickBuyTitle" tabindex="-1">' +
        '<button type="button" class="AaganQuickBuyModal__Close" data-aagan-quick-buy-close><span aria-hidden="true">&times;</span></button>' +
        '<h2 id="AaganQuickBuyTitle" class="AaganQuickBuyModal__Title Heading"></h2>' +
        '<label class="AaganQuickBuyModal__Label" for="AaganQuickBuyVariant"></label>' +
        '<select id="AaganQuickBuyVariant" class="AaganQuickBuyModal__Select"></select>' +
        '<button type="button" class="AaganQuickBuyModal__Add"></button>' +
        '<p class="AaganQuickBuyModal__Status" role="status" aria-live="polite"></p>' +
      '</div>';

    document.body.appendChild(modal);
    modalTitle = modal.querySelector('.AaganQuickBuyModal__Title');
    modalLabel = modal.querySelector('.AaganQuickBuyModal__Label');
    modalSelect = modal.querySelector('.AaganQuickBuyModal__Select');
    modalAdd = modal.querySelector('.AaganQuickBuyModal__Add');
    modalClose = modal.querySelector('.AaganQuickBuyModal__Close');
    modalStatus = modal.querySelector('.AaganQuickBuyModal__Status');

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-aagan-quick-buy-close]')) {
        closeModal();
      }
    });

    modalAdd.addEventListener('click', function () {
      addVariant(modalAdd, modalSelect.value, true);
    });

    modalSelect.addEventListener('change', function () {
      modalAdd.disabled = !modalSelect.value;
      modalStatus.textContent = '';
    });
  }

  function openModal(trigger) {
    createModal(trigger);

    var productDataElement = trigger.closest('.ProductItem__ImageArea').querySelector('[data-aagan-quick-buy-product]');
    var productData;

    try {
      productData = JSON.parse(productDataElement.textContent);
    } catch (error) {
      window.location.href = trigger.getAttribute('data-product-url');
      return;
    }

    activeTrigger = trigger;
    modalTitle.textContent = trigger.getAttribute('data-product-title');
    modalLabel.textContent = trigger.getAttribute('data-variant-label');
    modalAdd.textContent = trigger.getAttribute('data-add-label');
    modalClose.setAttribute('aria-label', trigger.getAttribute('data-close-label'));
    modalStatus.textContent = '';
    modalSelect.innerHTML = '';

    productData.variants.forEach(function (variant) {
      var option = document.createElement('option');
      option.value = variant.available ? variant.id : '';
      option.textContent = variant.title + ' – ' + variant.price + (variant.available ? '' : ' – ' + trigger.getAttribute('data-sold-out-label'));
      option.disabled = !variant.available;
      modalSelect.appendChild(option);
    });

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = '\u2014 ' + trigger.getAttribute('data-variant-label') + ' \u2014';
    placeholder.disabled = true;
    placeholder.selected = true;
    modalSelect.insertBefore(placeholder, modalSelect.firstChild);
    modalSelect.value = '';
    modalAdd.disabled = true;
    modal.hidden = false;
    document.body.classList.add('AaganQuickBuyModalOpen');
    modalClose.focus();
  }

  function closeModal() {
    if (!modal || modal.hidden) {
      return;
    }

    modal.hidden = true;
    document.body.classList.remove('AaganQuickBuyModalOpen');

    if (activeTrigger) {
      activeTrigger.focus();
    }

    activeTrigger = null;
  }

  function addVariant(button, variantId, fromModal) {
    if (!variantId || button.classList.contains('is-loading')) {
      return;
    }

    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    if (modalStatus) {
      modalStatus.textContent = '';
    }

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(localeCartUrl('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || 'This product could not be added to the cart.');
        }

        return data;
      });
    }).then(function (variant) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.disabled = false;

      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { variant: variant, quantity: 1 }
      }));

      if (fromModal) {
        closeModal();
      }
    }).catch(function (error) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.disabled = false;

      if (fromModal && modalStatus) {
        modalStatus.textContent = error.message;
      } else {
        button.setAttribute('title', error.message);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-aagan-quick-buy-trigger]');

    if (!trigger || trigger.disabled) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (trigger.getAttribute('data-has-variants') === 'true') {
      openModal(trigger);
    } else {
      addVariant(trigger, trigger.getAttribute('data-variant-id'), false);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!modal || modal.hidden) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      var focusable = [modalClose, modalSelect, modalAdd].filter(function (element) {
        return element && !element.disabled;
      });
      var currentIndex = focusable.indexOf(document.activeElement);

      if (event.shiftKey && currentIndex <= 0) {
        event.preventDefault();
        focusable[focusable.length - 1].focus();
      } else if (!event.shiftKey && currentIndex === focusable.length - 1) {
        event.preventDefault();
        focusable[0].focus();
      }
    }
  });
}());

/* Mobile sticky purchase action. Mirrors the real product form so product-option
   apps and Prestige's existing validation continue to own the add-to-cart flow. */
(function () {
  'use strict';

  function initialiseStickyBuy() {
    var stickyBuy = document.querySelector('[data-aagan-sticky-buy]');
    var stickyButton = document.querySelector('[data-aagan-sticky-buy-button]');
    var productButton = document.querySelector('.ProductForm__AddToCart');

    if (!stickyBuy || !stickyButton || !productButton) {
      return;
    }

    var stickyPrice = stickyBuy.querySelector('.AaganStickyBuy__Price');

    function syncStickyBuy() {
      var productButtonLabel = productButton.querySelector('span');
      var productPrice = document.querySelector('.ProductMeta__PriceList .AaganPrice--now') || document.querySelector('.ProductMeta__PriceList .ProductMeta__Price:not(.Price--compareAt)');

      stickyButton.disabled = productButton.disabled;
      stickyButton.textContent = productButtonLabel ? productButtonLabel.textContent.trim() : productButton.textContent.trim();

      if (stickyPrice && productPrice) {
        stickyPrice.textContent = productPrice.textContent.trim();
      }
    }

    function setStickyVisibility(visible) {
      stickyBuy.classList.toggle('is-visible', visible);
      stickyBuy.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyButton.tabIndex = visible ? 0 : -1;
    }

    stickyButton.addEventListener('click', function () {
      if (!productButton.disabled) {
        productButton.click();
      }
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        setStickyVisibility(!entries[0].isIntersecting);
      }, { threshold: 0.15 });

      observer.observe(productButton);
    }

    if ('MutationObserver' in window) {
      var buttonObserver = new MutationObserver(syncStickyBuy);
      buttonObserver.observe(productButton, { attributes: true, childList: true, subtree: true });
    }

    document.addEventListener('variant:changed', function () {
      window.setTimeout(syncStickyBuy, 0);
    });

    syncStickyBuy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseStickyBuy);
  } else {
    initialiseStickyBuy();
  }
}());

/* Display-only promotional pricing. Shopify still owns every cart and checkout value. */
(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderPromotionalPrice(root, variant) {
    var priceList = root.querySelector('.ProductMeta__PriceList');
    var priceDataElement = root.querySelector('[data-aagan-promotional-prices]');

    if (!priceList || !priceDataElement || !variant) {
      return;
    }

    var promotion;

    try {
      promotion = JSON.parse(priceDataElement.textContent);
    } catch (error) {
      return;
    }

    var prices = promotion.variants && promotion.variants[String(variant.id)];

    if (!prices || prices.eligible !== true) {
      return;
    }

    var checkoutNote = promotion.code ? 'Use ' + escapeHtml(promotion.code) + ' at checkout' : '';
    var noteSeparator = checkoutNote && promotion.note ? ' &middot; ' : '';

    priceList.className = 'ProductMeta__PriceList AaganPromotionalPrice Heading';
    priceList.innerHTML =
      '<span class="ProductMeta__Price AaganPrice AaganPrice--was Text--subdued u-h4">' +
        '<span class="AaganPrice__Label">Was</span>' +
        '<s class="AaganPrice__Amount" data-money-convertible>' + escapeHtml(prices.original) + '</s>' +
      '</span>' +
      '<span class="ProductMeta__Price AaganPrice AaganPrice--now u-h4">' +
        '<span class="AaganPrice__Label">Now</span>' +
        '<span class="AaganPrice__Amount" data-money-convertible>' + escapeHtml(prices.discounted) + '</span>' +
      '</span>' +
      ((checkoutNote || promotion.note) ? '<span class="AaganPromotionalPrice__Note">' + checkoutNote + noteSeparator + escapeHtml(promotion.note) + '</span>' : '');
  }

  document.addEventListener('variant:changed', function (event) {
    var productSection = event.target.closest('[data-section-id]') || document;
    renderPromotionalPrice(productSection, event.detail && event.detail.variant);
  });
}());
